@if (activeNavigationItem?.action == 'basicConfig') {
    <ei-structure-field-basic-component
            [structureFieldId]="objectIdentifier.objectId"></ei-structure-field-basic-component>
}
@if (activeNavigationItem?.action == 'fieldValues') {
    <ei-structure-field-values-component
            [structureFieldId]="objectIdentifier.objectId"
            [importTypeId]="importTypeId"></ei-structure-field-values-component>
}
@if (activeNavigationItem?.action == 'importLogic') {
    <ei-structure-field-import-logic-component
            [structureFieldId]="objectIdentifier.objectId"
            [importTypeId]="importTypeId"></ei-structure-field-import-logic-component>
}
